import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var CollapsedMenuLeft = function (props) { return (React.createElement(Icon, __assign({ width: '20px', height: '20px', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, props),
    React.createElement("path", { d: 'M3 10H7', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
    React.createElement("path", { d: 'M3 5H7', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
    React.createElement("path", { d: 'M3 15H7', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
    React.createElement("path", { d: 'M18.125 10H9.875', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
    React.createElement("path", { d: 'M13.25 6.625L9.875 10L13.25 13.375', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }))); };

export { CollapsedMenuLeft as default };
//# sourceMappingURL=CollapsedMenuLeft.js.map
